module.exports = __webpack_public_path__ + "media/apps/mitch-android-4-92efeaa0.png";